export default __webpack_public_path__ + "static/media/logo-allinfra.1639b5cd.png";